import { c as _c } from "react/compiler-runtime";
import { useColumnPreferencesContext } from "@context-providers/table/column-preferences-provider";
import { updatePreferencesWithOrder } from "@context-providers/table/column-preferences-utils";
import { FilterMenu } from "@flat-ui";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { setIsFilterMenuOpen, setOriginalColumnPreferences } from "@store/table/table-slice";
import { TableEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
export function FaroTableColumnVisibilityMenu(t0) {
  const $ = _c(42);
  const {
    labelsMap,
    disabledColumns: t1,
    forcedVisibleColumns: t2,
    tableType
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const disabledColumns = t3;
  let t4;
  if ($[2] !== t2) {
    t4 = t2 === undefined ? [] : t2;
    $[2] = t2;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const forcedVisibleColumns = t4;
  const dispatch = useAppDispatch();
  const {
    trackEvent
  } = useTrackEvent();
  const {
    updateColumnPreferences,
    updateColumnPreferencesLocally,
    columnPreferences,
    dataColumns
  } = useColumnPreferencesContext();
  const {
    isOpen,
    anchorPosition,
    originalColumnPreferences
  } = useAppSelector(_temp);
  let t5;
  if ($[4] !== columnPreferences || $[5] !== dispatch || $[6] !== originalColumnPreferences || $[7] !== tableType || $[8] !== trackEvent || $[9] !== updateColumnPreferences) {
    t5 = function handleCloseMenu() {
      if (!columnPreferences) {
        dispatch(setIsFilterMenuOpen(false));
        dispatch(setOriginalColumnPreferences(undefined));
        return;
      }
      if (originalColumnPreferences) {
        const changedColumns = Object.keys(columnPreferences).filter(key => {
          const isCurrentColumnVisible = columnPreferences[key]?.visible;
          const isOriginalColumnVisible = originalColumnPreferences[key]?.visible;
          return isCurrentColumnVisible !== undefined && isCurrentColumnVisible !== isOriginalColumnVisible;
        });
        for (const key_0 of changedColumns) {
          trackEvent({
            name: TableEvents.changeColumnVisibility,
            props: {
              type: tableType,
              column: key_0,
              value: columnPreferences[key_0]?.visible
            }
          });
        }
        if (changedColumns.length > 0) {
          updateColumnPreferences(columnPreferences);
        }
      }
      dispatch(setIsFilterMenuOpen(false));
      dispatch(setOriginalColumnPreferences(undefined));
    };
    $[4] = columnPreferences;
    $[5] = dispatch;
    $[6] = originalColumnPreferences;
    $[7] = tableType;
    $[8] = trackEvent;
    $[9] = updateColumnPreferences;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const handleCloseMenu = t5;
  let t6;
  if ($[11] !== columnPreferences || $[12] !== forcedVisibleColumns || $[13] !== updateColumnPreferencesLocally) {
    t6 = function handleFilterChange(newSelected) {
      if (!columnPreferences) {
        return;
      }
      const selectedKeys = new Set(newSelected.map(_temp2));
      for (const column of forcedVisibleColumns) {
        if (columnPreferences[column]?.visible) {
          selectedKeys.add(column);
        } else {
          selectedKeys.delete(column);
        }
      }
      const updatedPreferences = updatePreferencesWithOrder(columnPreferences, selectedKeys);
      updateColumnPreferencesLocally(updatedPreferences);
    };
    $[11] = columnPreferences;
    $[12] = forcedVisibleColumns;
    $[13] = updateColumnPreferencesLocally;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const handleFilterChange = t6;
  let t7;
  if ($[15] !== disabledColumns) {
    t7 = new Set(disabledColumns);
    $[15] = disabledColumns;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  const disabledColumnsSet = t7;
  let t8;
  if ($[17] !== forcedVisibleColumns) {
    t8 = new Set(forcedVisibleColumns);
    $[17] = forcedVisibleColumns;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const forcedVisibleColumnsSet = t8;
  let options;
  let t9;
  if ($[19] !== columnPreferences || $[20] !== dataColumns || $[21] !== disabledColumnsSet || $[22] !== forcedVisibleColumnsSet || $[23] !== labelsMap) {
    let t10;
    if ($[26] !== labelsMap) {
      t10 = field => field in labelsMap;
      $[26] = labelsMap;
      $[27] = t10;
    } else {
      t10 = $[27];
    }
    let t11;
    if ($[28] !== disabledColumnsSet || $[29] !== forcedVisibleColumnsSet || $[30] !== labelsMap) {
      t11 = field_0 => ({
        key: field_0,
        value: field_0,
        label: labelsMap[field_0],
        isDisabled: disabledColumnsSet.has(field_0) || forcedVisibleColumnsSet.has(field_0)
      });
      $[28] = disabledColumnsSet;
      $[29] = forcedVisibleColumnsSet;
      $[30] = labelsMap;
      $[31] = t11;
    } else {
      t11 = $[31];
    }
    options = dataColumns.filter(t10).map(t11);
    let t12;
    if ($[32] !== columnPreferences || $[33] !== forcedVisibleColumnsSet) {
      t12 = option => columnPreferences?.[option.key]?.visible === true || forcedVisibleColumnsSet.has(option.key);
      $[32] = columnPreferences;
      $[33] = forcedVisibleColumnsSet;
      $[34] = t12;
    } else {
      t12 = $[34];
    }
    t9 = options.filter(t12);
    $[19] = columnPreferences;
    $[20] = dataColumns;
    $[21] = disabledColumnsSet;
    $[22] = forcedVisibleColumnsSet;
    $[23] = labelsMap;
    $[24] = options;
    $[25] = t9;
  } else {
    options = $[24];
    t9 = $[25];
  }
  const selectedOptions = t9;
  let t10;
  if ($[35] !== anchorPosition || $[36] !== handleCloseMenu || $[37] !== handleFilterChange || $[38] !== isOpen || $[39] !== options || $[40] !== selectedOptions) {
    t10 = <FilterMenu open={isOpen} anchorReference="anchorPosition" anchorPosition={anchorPosition} headingLabel="Select Columns" options={options} selectedOptions={selectedOptions} onFilterChange={handleFilterChange} onFilterMenuClose={handleCloseMenu} showSearch={false} showClearAll={false} />;
    $[35] = anchorPosition;
    $[36] = handleCloseMenu;
    $[37] = handleFilterChange;
    $[38] = isOpen;
    $[39] = options;
    $[40] = selectedOptions;
    $[41] = t10;
  } else {
    t10 = $[41];
  }
  return t10;
}
function _temp2(opt) {
  return opt.key;
}
function _temp(state) {
  return state.table.filterMenu;
}